import { ArrowLeft, ArrowRight } from "lucide-react";
import FacebookMessengerConnectionCard from "@/components/admin_dashboard/FacebookMessengerConnectionCard";
import InstagramConnectionCard from "@/components/admin_dashboard/InstagramConnectionCard";
import LineConnectionCard from "@/components/admin_dashboard/LineConnectionCard";
import TelegramConnectionCard from "@/components/admin_dashboard/TelegramConnectionCard";
import WhatsAppConnectionCard from "@/components/admin_dashboard/WhatsAppConnectionCard";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { OnboardingData } from "@/pages/onboarding/Onboarding";

interface Props {
  data: OnboardingData;
  updateData: (fields: Partial<OnboardingData>) => void;
  nextStep: () => void | Promise<void>;
  prevStep: () => void;
  isFinalStep?: boolean;
  isSubmitting?: boolean;
}

const ChannelConnectionsStep = ({ data, updateData, nextStep, prevStep, isFinalStep = false, isSubmitting = false }: Props) => {

  return (
    <div className="flex min-h-full flex-1 flex-col">
      <div className="space-y-3">
        <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
          Messaging channels
        </p>
        <WhatsAppConnectionCard />
        <TelegramConnectionCard />
        <InstagramConnectionCard />
        <FacebookMessengerConnectionCard />
        <LineConnectionCard />
      </div>

      <div className="mt-6 space-y-3">
        <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
          Bookings
        </p>
        <div className="flex items-center justify-between gap-4 rounded-xl border border-border bg-card p-4 shadow-sm">
          <div className="flex min-w-0 items-center gap-4">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-red-50 p-2.5">
              <img
                src="/dibs_assets/red_logo_with_transparent_bg.png"
                alt=""
                className="h-full w-full object-contain"
              />
            </span>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-foreground">Dibs Bookings</p>
              <p className="mt-1 text-xs leading-relaxed text-muted-foreground">
                Add Dibs&apos; integrated storefront and booking-management system.
              </p>
            </div>
          </div>
          <Switch
            checked={data.enableDibsBookings}
            onCheckedChange={(checked) =>
              updateData({
                enableDibsBookings: checked,
                ...(checked ? { isYearly: false } : {}),
              })
            }
            aria-label="Add Dibs Bookings"
          />
        </div>
      </div>

      <div className="mt-auto flex justify-between pb-8 pt-6">
        <Button type="button" variant="outline" size="sm" onClick={prevStep} disabled={isSubmitting}>
          <ArrowLeft className="mr-1.5 h-4 w-4" />
          Back
        </Button>
        <Button type="button" size="sm" onClick={() => void nextStep()} disabled={isSubmitting}>
          {isFinalStep ? "Complete setup" : "Continue"} <ArrowRight className="ml-1.5 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default ChannelConnectionsStep;
